import {isRobLeniencyTask} from '~/types/rob';
import PropTypes from 'prop-types';

import MoreVertIcon from '~/images/md-icons/more_vert/materialicons/24px.svg';
import VerifiedUserIcon from '~/images/md-icons/verified_user/materialsymbolsoutlined/24px.svg';
import HealthAndSafetyIcon from '~/images/md-icons/health_and_safety/materialsymbolsoutlined/24px.svg';
import CarCrashIcon from '~/images/md-icons/car_crash/materialsymbolsoutlined/24px.svg';

const WarrantyIcon = ({value, ...rest}) => {
  let icon = <MoreVertIcon {...rest} />;

  if (value.warranty === 'Warranty') {
    icon = <VerifiedUserIcon fill="#299976" {...rest} />;
  } else if (isRobLeniencyTask(value.warranty)) {
    icon = <HealthAndSafetyIcon fill="#FF6C00" {...rest} />;
  } else if (value.is_damage) {
    icon = <CarCrashIcon fill="#FF6C00" {...rest} />;
  }

  return icon;
};

WarrantyIcon.propTypes = {
  value: PropTypes.shape({
    warranty: PropTypes.any,
    is_damage: PropTypes.any,
  }),
};

export default WarrantyIcon;
